import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { Theme } from 'scripts/react-components/themes/Theme'

import { MessageType } from '../../types'

type Type = { type: MessageType }

const messageWrapperStyle = ({ type }: Type) => css`
  label: chat-message-wrapper;

  display: flex;
  flex-direction: ${type === 'outcome' ? 'row-reverse' : 'row'};
  scroll-snap-align: end;
`
const userIconStyle = ({ theme, type }: Theme & Type) => css`
  label: user-side-icon;

  z-index: 50;
  border-radius: ${theme.borderRadius.circle};
  display: flex;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-top: ${theme.spacings.kilo};
  background-color: ${type === 'outcome'
    ? theme.colors.b700
    : theme.colors.p600};
  justify-content: center;
  align-items: center;
  padding: ${theme.spacings.bit};

  svg {
    fill: ${theme.colors.white};
  }
`

const baloonsContainerStyle = () => css`
  label: baloons-container;

  padding: 0 11px;
  display: grid;
  grid-gap: 6px;
`

const baloonStyle = ({ theme }: Theme) => css`
  label: baloon;

  border-radius: ${theme.borderRadius.giga};
  background: ${theme.colors.white};
  padding: ${theme.spacings.kilo};
  position: relative;

  box-shadow: 0px 4px 4px 0px rgba(60, 55, 56, 0.07),
    0px 2px 2px 0px rgba(60, 55, 56, 0.07),
    0px 0px 0px 1px rgba(186, 182, 188, 0.07);

  color: ${theme.colors.n800};
  font-size: ${theme.typography.text.kilo.fontSize};
  font-feature-settings: 'clig' off, 'liga' off;
  line-height: 120%;
  white-space: pre-line;

  &::before {
    width: 10px;
    height: 10px;
    content: '';
    position: absolute;
    transform: rotate(45deg);
    top: 18px;
    background-color: ${theme.colors.white};
    fill: ${theme.colors.white};
    left: -5px;
    box-shadow: rgba(60, 55, 56, 0.07) -1px 2px 0px 0px,
      rgba(60, 55, 56, 0.07) -1px 1px 0px 0px;
  }
`

const baloonOutcomeStyle = ({ theme, type }: Theme & Type) =>
  type === 'outcome' &&
  css`
    label: baloon--outcome;

    background: ${theme.colors.p100};

    &::before {
      background-color: ${theme.colors.p100};
      fill: ${theme.colors.p100};
      left: auto;
      right: -5px;
      box-shadow: rgba(60, 55, 56, 0.07) 1px -2px 0px 0px,
        rgba(60, 55, 56, 0.07) 1px -1px 0px 0px;
    }
  `

export const MessageWrapper = styled('div')(messageWrapperStyle)
export const UserIcon = styled('div')(userIconStyle)
export const BaloonsContainer = styled('div')(baloonsContainerStyle)
export const Baloon = styled('div')(baloonStyle, baloonOutcomeStyle)
